module.exports = __webpack_public_path__ + "img/pr-8.3263d9bf.png";